<template>
  <div v-if="filtered">
    <v-data-table
      :headers="headers"
      :items="attendances"
      :server-items-length="attendanceCount"
      :options.sync="tableOptions"
      item-key="id"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
      disable-sort
    >
      <!-- Học sinh -->
      <template #item.student="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Ngày sinh -->
      <template #item.dob="{ item }">
        <span>{{ (item.student && item.student.dob) | ddmmyyyy }}</span>
      </template>
      <!-- Ngày -->
      <template #item.date="{ item }">
        {{ item.time | ddmmyyyy }}
      </template>
      <!-- Lớp -->
      <template #item.class="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class.id)">
          <span v-if="item.class">{{ item.class && item.class.title }}</span>
        </router-link>
      </template>
      <!-- Giờ đến / Giờ về -->
      <template #item.time="{ item }">
        <div v-if="item.checkins && item.checkins.length">
          <div class="pt-2" style="height: 36px" v-for="checkin in item.checkins" :key="checkin.id">
            {{ checkin.checkIn | hhmm }} / {{ checkin.checkOut | hhmm }}
            <v-icon small right @click="openEditDialog(item, checkin)">mdi-pencil</v-icon>
          </div>
        </div>
        <div v-else>--:-- / --:-- <v-icon small right @click="openEditDialog(item, {})">mdi-pencil</v-icon></div>
      </template>
      <!-- Trạng thái -->
      <template #item.status="{ item }">
        <div v-if="item.checkins && item.checkins.length">
          <div v-for="checkin in item.checkins" :key="checkin.id" class="pt-2" style="height: 36px">
            <v-chip small label :color="checkin.status | getAttendanceStatusColor" dark>
              <span>
                {{ checkin.status | getAttendanceStatus }}
              </span>
            </v-chip>
          </div>
        </div>
        <div v-else>
          <v-chip small label color="#FD6B6B" dark>
            <span> Chưa điểm danh </span>
          </v-chip>
        </div>
      </template>
      <!-- Thao tác -->
      <!-- <template #item.action="{ item }">
        <div v-if="item.checkins && item.checkins.length">
          <div v-for="checkin in item.checkins" :key="checkin.id">
            <AttendanceListActions
              :selectedAttendance="item"
              :checkinObject="checkin"
              @attendanceUpdated="searchAttendances(attendanceSearchParams)"
            />
          </div>
        </div>
        <div v-else>
          <AttendanceListActions
            :selectedAttendance="item"
            :checkinObject="{}"
            @attendanceUpdated="searchAttendances(attendanceSearchParams)"
          />
        </div>
      </template> -->
    </v-data-table>
    <EditAttendanceDialog
      :selectedAttendance="selectedAttendance"
      :checkinObject="selectedCheckin"
      :state="editDialog"
      @attendanceUpdated="searchAttendances(attendanceSearchParams)"
    />
  </div>
  <div v-else class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16">
    Vui lòng cung cấp các thông tin ở trên, sau đó ấn [Tìm kiếm] để kiểm tra trạng thái điểm danh
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import utils from '@/plugins/utils'
// import AttendanceListActions from './AttendanceListActions'
import CardStudentName from '@/views/student/components/CardStudentName'
import EditAttendanceDialog from './EditAttendanceDialog.vue'

const defaultHeaders = [
  { text: 'Học sinh', value: 'student', width: 200, sortable: true },
  {
    text: 'Ngày sinh',
    value: 'dob',
    width: 100,
    sortable: false,
  },
  { text: 'Lớp', value: 'class', width: 100, sortable: false },
  {
    text: 'Giờ đến / Giờ về',
    value: 'time',
    sortable: false,
    align: 'left',
  },
  { text: 'Trạng thái', value: 'status', sortable: false, align: 'left' },
  // { text: 'Thao tác', value: 'action', width: 100, sortable: false },
]

export default {
  components: {
    // AttendanceListActions,
    CardStudentName,
    EditAttendanceDialog,
  },
  data() {
    return {
      filtered: false,
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      attendanceSearchParams: {},
      attendanceCount: 0,
      editDialog: true,
      selectedAttendance: {},
      selectedCheckin: {},
      loading: false,
    }
  },
  computed: {
    ...mapState('attendance', ['attendances']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.attendanceCount),
        itemsPerPageOptions: [10, 20, 40, 100],
      }
      return footerOptions
    },
  },
  methods: {
    ...mapActions('attendance', ['getManyAttendances', 'getAttendanceCount']),

    async searchAttendances(attendanceFilters) {
      this.filtered = true
      this.loading = true
      // New filter
      if (attendanceFilters) {
        let attendanceParams = {}
        if (attendanceFilters.student) {
          attendanceParams.student = attendanceFilters.student
        } else {
          if (attendanceFilters.class) {
            attendanceParams.class = attendanceFilters.class
          } else {
            if (attendanceFilters.grade) {
              attendanceParams.grade = attendanceFilters.grade
            }
          }
        }
        if (attendanceFilters.status) {
          attendanceParams.status = attendanceFilters.status
        }
        if (attendanceFilters.time) {
          attendanceParams = {
            ...attendanceParams,
            time_gte: moment(attendanceFilters.time).startOf('day').toISOString(),
            time_lte: moment(attendanceFilters.time).endOf('day').toISOString(),
          }
        }

        this.getAttendanceCount(attendanceParams)
          .then(response => {
            this.attendanceCount = response
          })
          .catch(error => {
            console.error(error)
            this.$alert.error('Không lấy được số lượng điểm danh. Lỗi : ', error)
          })
        this.tableOptions.page = 1
        this.attendanceSearchParams = { ...attendanceParams, ...this.pageSetting() }
      } else {
        this.attendanceSearchParams = { ...this.attendanceSearchParams, ...this.pageSetting() }
      }
      try {
        await this.getManyAttendances({ searchParams: this.attendanceSearchParams })
        // console.log(this.attendances)
      } catch (error) {
        this.$alert.error('Không lấy được danh sách điểm danh. Lỗi : ', error)
        console.error(error)
      }
      this.loading = false
    },
    async openEditDialog(attendance, checkin) {
      this.selectedAttendance = attendance
      this.selectedCheckin = checkin
      this.$nextTick(() => {
        this.editDialog = !this.editDialog
      })
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: 'studentNameToNumber:ASC',
      }
    },
  },
  watch: {
    tableOptions: {
      async handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          await this.getManyAttendances({
            searchParams: {
              ...this.attendanceSearchParams,
              _start: (newOptions.page - 1) * newOptions.itemsPerPage,
              _limit: newOptions.itemsPerPage,
            },
          })
        }
      },
      deep: true,
    },
  },
}
</script>
